<template>
    <v-container fluid>
      <ExportarIBMaker v-if="$store.state.emp.cod_empresa == 469"/>
      <ExportarJadip v-if="$store.state.emp.cod_empresa == 493"/>
      <ExporPersonal v-if="$store.state.emp.cod_empresa == 398"/>
      <ExporSuc v-if="$store.state.emp.cod_empresa == 494"/>
      <ExporAbel v-if="$store.state.emp.cod_empresa == 476"/>
      <ExporErret v-if="$store.state.emp.cod_empresa == 473"/>

    </v-container>
  </template>
  
  <script>

  import ExportarIBMaker from './IBMaker/ExporIBM.vue';
  import ExportarJadip from './Jadip/ExporJadip.vue';
  import ExporPersonal from './PersonalSoft/ExporPersonal.vue';
  import ExporSuc from './SucGomez/ExporSuc.vue';
  import ExporAbel from './Abel/ExporAbel.vue';
  import ExporErret from './Erret/ExporErret.vue';
  
  export default {
    data: () => ({
      //
    }),
    components: {
        ExportarIBMaker,
        ExportarJadip,
        ExporPersonal,
        ExporSuc,
        ExporAbel,
        ExporErret
    },
  };
  </script>